module.exports = __webpack_public_path__ + "img/technical-support.6ba8eb18.png";